<div class="row mt-5">
  <div class="col-12">
    <div class="text-end">
      <button type="button" (click)="refreshActionStatus()"
              class="btn btn-primary btn-sm fw-bold">
        Refresh
      </button>
      <button type="button" (click)="linkToMicrosoftAdvertising()" *isGranted="['ROLE_API_PARTNER_WRITE']"
              class="btn btn-danger btn-sm fw-bold ms-1">
        Link with Microsoft Advertising
      </button>
    </div>
    @if (conversionGoals === null) {
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    }
    @if (conversionGoals !== null) {
      <table class="table">
        <thead>
        <tr>
          <th>Conversion Goal Name</th>
          <th>ID</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
          @for (goal of conversionGoals; track goal) {
            <tr>
              <td>{{ goal.name }}</td>
              <td>{{ goal.id }}</td>
              <td>
                @if (goal.enabled) {
                  <span class="text-success">Enabled</span>
                } @else {
                  <span class="text-danger">⚠️ NOT CONFIGURED</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
